import reduxMount from './../../jsCore/utils/reduxMounter'
import { MOUNT_POINTS } from './../../jsCore/config/preRenderedSelectorsConfig'
import { userStatsContainer } from './Stats.container'

const COMPONENT_NAME = 'userStats'
const STATE_KEY = 'userStats'

export const init = () =>
  reduxMount({
    [MOUNT_POINTS.USER_STATS]: userStatsContainer({
      componentName: COMPONENT_NAME,
      stateKey: STATE_KEY,
    }),
  })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/user_stats/index.js